import { onBeforeUnmount } from 'vue'

import { lockScroll, unlockScroll } from '../utils/scrollLock'

export function useScrollLock() {
  let locked = false

  function lock() {
    if (locked) return
    locked = true
    lockScroll()
  }

  function unlock() {
    if (!locked) return
    locked = false
    unlockScroll()
  }

  onBeforeUnmount(unlock)

  return { lock, unlock }
}
